import { Center } from '@mantine/core';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Text } from '../../../ui-library/typography/typography';

type Props = {
  error: string;
  showRedirectMessage?: boolean;
};

export const AddNewIntegrationError = ({ error, showRedirectMessage = true }: Props) => {
  const navigate = useNavigate();

  useEffect(() => {
    console.error('AddNewIntegration error received:', error);

    if (showRedirectMessage) {
      const timer = setTimeout(() => {
        navigate('/application/integrations', { replace: true });
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [error, showRedirectMessage, navigate]);

  return (
    <Center style={{ height: '100vh', flexDirection: 'column', gap: 16 }}>
      <Text size="large" color="red">
        Add New Integration Error
      </Text>
      <Text size="medium">{error}</Text>
      {showRedirectMessage && (
        <Text size="small" color="dimmed">
          Redirecting back to add new integrations page...
        </Text>
      )}
    </Center>
  );
};
